/**
 * Static readonly implementations of the region references within the aHub
 */
export class RequestActionStatusEnum {
	static readonly WAITING: string = "waiting";
	static readonly RUNNING: string = "running";
	static readonly ERROR: string = "error";
	static readonly COMPLETED: string = "completed";
}
